import React, {Component} from 'react'
import {observer, inject} from 'mobx-react'
import DocumentTitle from 'react-document-title'
import ReCaptcha from 'react-google-recaptcha'
import {Input, Button} from 'antd'

import style from './contact.sass'

@inject('store') @observer
class Contact extends Component {
  handleChange = (e) => {
    const {name, value} = e.target
    this.props.store.public.changeCredentials('contact', name, value)
  }
  handleFocus = (e) => {
    this.props.store.public.removeError('contact', e.target.name)
  }
  handleSubmit = () => {
    this.props.store.public.sendLetter()
  }
  handleRecaptcha = (value) => {
    this.props.store.public.changeCredentials('contact', 'recaptcha_response', value)
  }
  render() {
    const {credentials, errors, loading} = this.props.store.public.contact
    const captchaComplete = !!credentials.recaptcha_response
    return(
      <div>
        <DocumentTitle title='Contact Us'/>
        <div>
          <div styleName='banner'>
            <h3>Contact Us</h3>
          </div>
          <section className='bg-white'>
            <div className='landing-container' styleName='container'>
              <p>We&apos;d love to hear from you!</p>
              <h5>Please email us at <a href='mailto:info@algoriz.com'>info@algoriz.com</a> or submit the form below.</h5>
              <form styleName='form'>
                <div>
                  <label htmlFor='first_name'>First Name <span>*</span></label>
                  <Input
                    type='text'
                    name='first_name'
                    size='large'
                    value={credentials.first_name}
                    onChange={this.handleChange}
                    onFocus={this.handleFocus}
                  />
                  <p styleName='error'>{errors.first_name}</p>
                </div>
                <div>
                  <label htmlFor='first_name'>Last Name <span>*</span></label>
                  <Input
                    type='text'
                    name='last_name'
                    size='large'
                    value={credentials.last_name}
                    onChange={this.handleChange}
                    onFocus={this.handleFocus}
                  />
                  <p styleName='error'>{errors.last_name}</p>
                </div>
                <div>
                  <label htmlFor='email'>Email <span>*</span></label>
                  <Input
                    type='email'
                    name='email'
                    size='large'
                    value={credentials.email}
                    onChange={this.handleChange}
                    onFocus={this.handleFocus}
                  />
                  <p styleName='error'>{errors.email}</p>
                </div>
                <div>
                  <label htmlFor='phone'>Phone</label>
                  <Input
                    type='text'
                    name='phone'
                    size='large'
                    value={credentials.phone}
                    onChange={this.handleChange}
                    onFocus={this.handleFocus}
                  />
                  <p styleName='error'>{errors.phone}</p>
                </div>
                <div styleName='message'>
                  <label htmlFor='message'>Message <span>*</span></label>
                  <Input.TextArea
                    name='message'
                    size='large'
                    value={credentials.message}
                    onChange={this.handleChange}
                    onFocus={this.handleFocus}
                  />
                  <p styleName='error'>{errors.message}</p>
                </div>
                <div>
                  <ReCaptcha
                    sitekey='6LeZ7T0UAAAAANszyCDgGufTqBUHqXp6kKYcVtjf'
                    onChange={this.handleRecaptcha}
                  />
                </div>
                <Button type='primary' onClick={this.handleSubmit} loading={loading} disabled={!captchaComplete}>Submit</Button>
              </form>
            </div>
          </section>
        </div>
      </div>
    )
  }
}

export default Contact
